var render = function render(){var _vm=this,_c=_vm._self._c;return _c('GridCard',[_c('GridContent',[_c('GridHeader',{attrs:{"title":_vm.title}}),_c('FieldSelect',{attrs:{"multiple":true,"options":_vm.options,"border":true,"selected":_vm.value,"sorted":false},on:{"input":e => _vm.$emit('change', _vm.value = e)}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }